import { render, staticRenderFns } from "./AccessList.vue?vue&type=template&id=86e85d2c"
import script from "./AccessList.vue?vue&type=script&lang=js"
export * from "./AccessList.vue?vue&type=script&lang=js"
import style0 from "./AccessList.vue?vue&type=style&index=0&id=86e85d2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports